import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'lib-main-theses',
    templateUrl: './main-theses.component.html',
    styleUrls: ['./main-theses.component.scss']
})
export class MainThesesComponent implements OnInit {

    @Input() lang: 'uk' | 'en' = 'en';
    // @Input() items: any[] = [];
    //
    // translate = {
    //     uk: {
    //         items: [
    //             {
    //                 text: 'Anima визначає рівень депресії та тривожності за допомогою зображень і вебкамери, що фіксує найменші рухи очей, перетворюючи їх на об’єктивний індикатор стану.',
    //                 link: 'https://www.bloomberg.com/news/features/2023-08-10/how-ukraine-s-innovative-military-gadgetry-is-helping-fend-off-russia-s-invasion#:~:text=It%20uses%20an%20image%2Dbased%20test%20to%20measure%20levels%20of%20depression%20and%20anxiety%20with%20a%20web%20cam%20that%20follows%20eye%20movement%20to%20add%20objectivity.',
    //                 img: 'assets/img/bloomberg.png',
    //                 details: 'Докладніше'
    //             },
    //             {
    //                 text: 'Фіксуючи мікрорухи очей із точністю до мілісекунди, тест дає змогу виявити справжню, неприховану реакцію людини.',
    //                 link: 'https://www.npr.org/2023/08/14/1193759605/with-a-simple-question-ukrainians-probe-mental-health-at-a-time-of-war#:~:text=By%20measuring%20eye%20movements%20to%20the%20millisecond%2C%20the%20test%20seeks%20to%20determine%20a%20person%27s%20unguarded%20reaction',
    //                 img: '/assets/img/npr.png',
    //                 details: 'Докладніше'
    //             }],
    //     },
    //     en: {
    //
    //     }
    // };
    items = [
        {
            text: 'Anima uses an image-based test to measure levels of depression and anxiety with a web cam that follows eye movement to add objectivity.',
            link: 'https://www.bloomberg.com/news/features/2023-08-10/how-ukraine-s-innovative-military-gadgetry-is-helping-fend-off-russia-s-invasion#:~:text=It%20uses%20an%20image%2Dbased%20test%20to%20measure%20levels%20of%20depression%20and%20anxiety%20with%20a%20web%20cam%20that%20follows%20eye%20movement%20to%20add%20objectivity.',
            img: 'assets/img/bloomberg.png',
            details: 'Read more'
        },
        {
            text: 'By measuring eye movements to the millisecond, the test seeks to determine a person\'s unguarded reaction.',
            link: 'https://www.npr.org/2023/08/14/1193759605/with-a-simple-question-ukrainians-probe-mental-health-at-a-time-of-war#:~:text=By%20measuring%20eye%20movements%20to%20the%20millisecond%2C%20the%20test%20seeks%20to%20determine%20a%20person%27s%20unguarded%20reaction',
            img: '/assets/img/npr.png',
            details: 'Read more'
        }];

    constructor() {
    }

    ngOnInit(): void {
    }


}
